import { CreatePluginMessageMap, WebviewId } from '@gitlab-org/webview-plugin';

export const WEBVIEW_ID = 'duo-chat' as WebviewId;
export const WEBVIEW_TITLE = 'GitLab Duo Chat';

type Record = {
  id: string;
};

export interface GitlabChatSlashCommand {
  name: string;
  description: string;
  shouldSubmit?: boolean;
}

export interface WebViewInitialStateInterface {
  slashCommands: GitlabChatSlashCommand[];
}

export type GitLabChatFileContext = {
  fileName: string;
  selectedText: string;
  contentAboveCursor: string | null;
  contentBelowCursor: string | null;
};

export type Messages = CreatePluginMessageMap<{
  pluginToWebview: {
    notifications: {
      newRecord: Record;
      updateRecord: Record;
      setLoadingState: boolean;
      cleanChat: undefined;
    };
  };
  webviewToPlugin: {
    notifications: {
      onReady: undefined;
      cleanChat: undefined;
      newPrompt: {
        record: {
          content: string;
        };
      };
      trackFeedback: {
        data?: {
          extendedTextFeedback: string | null;
          feedbackChoices: Array<string> | null;
        };
      };
    };
  };
  pluginToExtension: {
    notifications: {
      showErrorMessage: {
        message: string;
      };
    };
    requests: {
      getCurrentFileContext: {
        params: undefined;
        result: GitLabChatFileContext;
      };
    };
  };
}>;
